import { ColumnDefWithTooltip } from "src/components/Table/Table";
import { ColumnId } from "./constants";

type Row = {
  schoolForm: { waitlist: { position: number | null } | null } | null;
};
export function buildWaitlistPositionColumnDef<
  T extends Row
>(): ColumnDefWithTooltip<T> {
  return {
    id: ColumnId.WaitlistPosition,
    header: "Waitlist position",
    tooltip: "Sort by waitlist position",
    accessorFn: (row) => row.schoolForm?.waitlist?.position,
  };
}
